import ProductTabs from './ProductTabs';

export default ProductTabs;
